export const filtersData = [
  {
    label: `SIZE`,
    name: `filterSize`,
    items: [
      {
        name: `Oversized`,
        value: `Oversized`,
      },
      {
        name: `12' x 18'`,
        value: `12 x 18`,
      },
      {
        name: `10' x 14'`,
        value: `10 x 14`,
      },
      {
        name: `9' x 12'`,
        value: `9 x 12`,
      },
      {
        name: `8' x 10'`,
        value: `8 x 10`,
      },
      {
        name: `6' x 9'`,
        value: `6 x 9`,
      },
      {
        name: `4' x 6'`,
        value: `4 x 6`,
      },
      {
        name: `Entry/Foyer`,
        value: `Entry/Foyer`,
      },
      {
        name: `Small`,
        value: `Small`,
      },
      {
        name: `Runners`,
        value: `Runners`,
      },
      {
        name: `Runners Under 3’3”`,
        value: `Runners Under 3’3”`,
      },
    ],
  },
  {
    label: `COLOR`,
    name: `antiquesRugsColor`,
    items: [
      {
        name: `Ivory`,
        value: `Ivory`,
      },
      {
        name: `Camel`,
        value: `Camel`,
      },
      {
        name: `Taupe`,
        value: `Taupe`,
      },
      {
        name: `Brown`,
        value: `Brown`,
      },
      {
        name: `Blue`,
        value: `Blue`,
      },
      {
        name: `Red`,
        value: `Red`,
      },
      {
        name: `Yellow`,
        value: `Yellow`,
      },
    ],
  },
  // {
  //   label: `STYLE`,
  //   name: `antiqueStyle`,
  //   items: [
  //     {
  //       name: `AGRA`,
  //       value: `AGRA`,
  //     },
  //     {
  //       name: `BIDJAR`,
  //       value: `BIDJAR`,
  //     },
  //     {
  //       name: `CHINESE`,
  //       value: `CHINESE`,
  //     },
  //     {
  //       name: `EUROPEAN OF SULTANABAD DESIGN`,
  //       value: `EUROPEAN OF SULTANABAD DESIGN`,
  //     },
  //     {
  //       name: `FERAGHAN`,
  //       value: `FERAGHAN`,
  //     },
  //     {
  //       name: `FERAGHAN MAHAL`,
  //       value: `FERAGHAN MAHAL`,
  //     },
  //     {
  //       name: `HAJI JALLILI TABRIZ`,
  //       value: `HAJI JALLILI TABRIZ`,
  //     },
  //     {
  //       name: `HERIZ`,
  //       value: `HERIZ`,
  //     },
  //     {
  //       name: `INDIAN`,
  //       value: `INDIAN`,
  //     },
  //     {
  //       name: `KARABAGH`,
  //       value: `KARABAGH`,
  //     },
  //     {
  //       name: `KARAJA`,
  //       value: `KARAJA`,
  //     },
  //     {
  //       name: `KASHGAI`,
  //       value: `KASHGAI`,
  //     },
  //     {
  //       name: `KERMAN LAVAR`,
  //       value: `KERMAN LAVAR`,
  //     },
  //     {
  //       name: `KHOTAN`,
  //       value: `KHOTAN`,
  //     },
  //     {
  //       name: `KIRMAN`,
  //       value: `KIRMAN`,
  //     },
  //     {
  //       name: `KIRMAN LAVAR`,
  //       value: `KIRMAN LAVAR`,
  //     },
  //     {
  //       name: `KIRMAN PALACE CARPET`,
  //       value: `KIRMAN PALACE CARPET`,
  //     },
  //     {
  //       name: `KURDISH`,
  //       value: `KURDISH`,
  //     },
  //     {
  //       name: `MAHAL`,
  //       value: `MAHAL`,
  //     },
  //     {
  //       name: `MALAYAIR`,
  //       value: `MALAYAIR`,
  //     },
  //     {
  //       name: `MALAYER`,
  //       value: `MALAYER`,
  //     },
  //     {
  //       name: `MALAYIR`,
  //       value: `MALAYIR`,
  //     },
  //     {
  //       name: `MALLAYER`,
  //       value: `MALLAYER`,
  //     },
  //     {
  //       name: `MASHAD`,
  //       value: `MASHAD`,
  //     },
  //     {
  //       name: `MOHTASHEM KASHAN`,
  //       value: `MOHTASHEM KASHAN`,
  //     },
  //     {
  //       name: `NORTHWEST PERSIAN`,
  //       value: `NORTHWEST PERSIAN`,
  //     },
  //     {
  //       name: `OUSHAK`,
  //       value: `OUSHAK`,
  //     },
  //     {
  //       name: `SAROUK FERAGHAN`,
  //       value: `SAROUK FERAGHAN`,
  //     },
  //     {
  //       name: `SERAPI`,
  //       value: `SERAPI`,
  //     },
  //     {
  //       name: `SHIRAZ`,
  //       value: `SHIRAZ`,
  //     },
  //     {
  //       name: `SHIRVAN`,
  //       value: `SHIRVAN`,
  //     },
  //     {
  //       name: `SULTANABAD`,
  //       value: `SULTANABAD`,
  //     },
  //     {
  //       name: `TABRIZ`,
  //       value: `TABRIZ`,
  //     },
  //     {
  //       name: `TURKISH`,
  //       value: `TURKISH`,
  //     },
  //     {
  //       name: `TURKISH OUSHAK`,
  //       value: `TURKISH OUSHAK`,
  //     },
  //     {
  //       name: `USHAK`,
  //       value: `USHAK`,
  //     },
  //     {
  //       name: `ZEKI MUREN`,
  //       value: `ZEKI MUREN`,
  //     },
  //     {
  //       name: `ZIEGLER`,
  //       value: `ZIEGLER`,
  //     },
  //     {
  //       name: `ZIEGLER MAHAL`,
  //       value: `ZIEGLER MAHAL`,
  //     },
  //   ],
  // },
  // {
  //   label: `ORIGIN`,
  //   name: `origin`,
  //   items: [
  //     {
  //       name: `ANATOLIA`,
  //       value: `ANATOLIA`,
  //     },
  //     {
  //       name: `AZERBIJAN`,
  //       value: `AZERBIJAN`,
  //     },
  //     {
  //       name: `CENTRAL PERSIA`,
  //       value: `CENTRAL PERSIA`,
  //     },
  //     {
  //       name: `CHINA`,
  //       value: `CHINA`,
  //     },
  //     {
  //       name: `EAST CAUCASUS`,
  //       value: `EAST CAUCASUS`,
  //     },
  //     {
  //       name: `EAST PERSIA`,
  //       value: `EAST PERSIA`,
  //     },
  //     {
  //       name: `EAST TURKESTAN`,
  //       value: `EAST TURKESTAN`,
  //     },
  //     {
  //       name: `INDIA`,
  //       value: `INDIA`,
  //     },
  //     {
  //       name: `NORTH EAST PERSIA`,
  //       value: `NORTH EAST PERSIA`,
  //     },
  //     {
  //       name: `NORTH INDIA`,
  //       value: `NORTH INDIA`,
  //     },
  //     {
  //       name: `NORTH WEST PERSIA`,
  //       value: `NORTH WEST PERSIA`,
  //     },
  //     {
  //       name: `PERSIA`,
  //       value: `PERSIA`,
  //     },
  //     {
  //       name: `PERSIAN KURDISTAN`,
  //       value: `PERSIAN KURDISTAN`,
  //     },
  //     {
  //       name: `SOUTH CAUCASUS`,
  //       value: `SOUTH CAUCASUS`,
  //     },
  //     {
  //       name: `SOUTH EAST CAUCASUS`,
  //       value: `SOUTH EAST CAUCASUS`,
  //     },
  //     {
  //       name: `SOUTH EAST PERSIA`,
  //       value: `SOUTH EAST PERSIA`,
  //     },
  //     {
  //       name: `SOUTH WEST PERSIA`,
  //       value: `SOUTH WEST PERSIA`,
  //     },
  //     {
  //       name: `SULTANABAD`,
  //       value: `SULTANABAD`,
  //     },
  //     {
  //       name: `TURKEY`,
  //       value: `TURKEY`,
  //     },
  //     {
  //       name: `WEST ANATOLIA`,
  //       value: `WEST ANATOLIA`,
  //     },
  //     {
  //       name: `WEST PERSIA`,
  //       value: `WEST PERSIA`,
  //     },
  //   ],
  // },
]

export const sortByOptions = [
  {
    value: `Please Select`,
    selected: true,
  },
  {
    value: `Best Selling`,
  },
  {
    value: `Alphabetically, A-Z`,
  },
  {
    value: `Alphabetically, Z-A`,
  },
  {
    value: `Price, low to high`,
  },
  {
    value: `Price, high to low`,
  },
]
